/* eslint-disable no-unused-vars */
import apiClient from "@/config/api";
const RESOURCE = "/properties";

const actions = {
  getTicketByEmail({ commit }, email) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };

    return new Promise((resolve, reject) => {
      apiClient
        .get(`${RESOURCE}/?${email}`, config)
        .then((res) => {
          // commit();
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
  storeTicket({ commit }, ticketData) {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    };
    return new Promise((resolve, reject) => {
      apiClient
        .post("/tickets", ticketData, config)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
          console.error("API Error:", err);
        });
    });
  },
};
export default actions;
